<template>
  <svg :width="width" :height="height">
    <g :transform="graphTransform">
      <g v-if="data.length" >
        <text dx="-10" dy="-20" :x="graphWidth / 2 - labelWidth" text-anchor="end" >
          {{ data[0].leftLabel }}
        </text>
        <text
           dx="10"
           dy="-20"
           text-anchor="start"
           :x="graphWidth / 2 + labelWidth" >
          {{ data[0].rightLabel }}
        </text>
      </g>
      <g v-for="(bar, i) in data" class="group" :transform="translateY(i)" >
        <rect :width="graphWidth" :height="barWidth - gap" fill="none" pointer-events="all" />
        <popover :content="yFormatter(bar.left)" :delay="100" :hideDelay="100" position="left" >
          <rect
             class="bar hoverable"
             :width="leftWidth(bar)"
             :height="barWidth - gap"
             :x="leftX(bar)"
             :fill="color" />
        </popover>
        <popover :content="yFormatter(bar.right)" :delay="100" :hideDelay="100" position="right" >
          <rect
             class="bar hoverable"
             :width="rightWidth(bar)"
             :height="barWidth - gap"
             :x="graphWidth / 2 + labelWidth"
             :fill="color" />
        </popover>        
        <ellipsis
           :x="graphWidth / 2"
           dy="1em"
           text-anchor="middle"
           :alwaysPopover="false"
           :text="bar.label"
           :width="labelWidth * 2" />
      </g>
    </g>
  </svg>
</template>

<style scoped>
.group rect.bar {
    opacity: 0.7;
}
.group:hover rect.bar {
    opacity: 1;
}
</style>

<script>
import * as d3 from 'd3'
import Graph from './Graph.vue'
import Popover from './Popover.vue'
import Ellipsis from './Ellipsis.vue'
import margin from '../mixins/margin.js'

export default {
  extends: Graph,
  components: {
    Popover: Popover,
    Ellipsis: Ellipsis
  },
  mixins: [
    margin
  ],
  props: {
    width: {
      type: Number,
      default: 960
    },
    height: {
      type: Number,
      default: 500
    },
    gap: {
      type: Number,
      default: 2
    },
    labelWidth: {
      type: Number,
      default: 80
    },
    color: {
      type: String,
      default: 'steelblue'
    }
  },
  computed: {
    total () {
      return d3
        .scaleLinear()
        .domain([0, d3.max(this.data.map(d => Math.max(d.left, d.right)))])
        .range([0, this.graphWidth / 2 - this.labelWidth * 2])
    },
    translateY () {
      return i => 'translate(0,' + this.yScale(i) + ')'
    },
    yScale () {
      return d3
        .scaleLinear()
        .domain([0, this.data.length])
        .range([0, this.graphHeight])
    },
    barWidth () {
      return this.graphHeight / this.data.length
    },
    leftWidth () {
      return bar => this.total(bar.left)
    },
    rightWidth () {
      return bar => this.total(bar.right)
    },
    leftX () {
      return bar => {
        return this.graphWidth / 2 - this.total(bar.left) - this.labelWidth
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Pyramid.vue